import React, { useState } from "react";
import { X } from "lucide-react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import ModalWrapper from "../Modal";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { createShippingCountry } from "../../services/shippingService";

const AddCountryModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    country: "",
  });

  const { mutate: handleCreate, isPending } = useMutation({
    mutationFn: () => createShippingCountry(formData),
    onSuccess: () => {
      toast.success("Country created successfully!");
      setFormData({
        country: "",
      });
      onClose();
      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      toast.error(getErrorMessage(error, "Failed to create country."));
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (!formData.country.trim()) {
      toast.error("Please enter a country name");
      return;
    }
    handleCreate();
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose} hasPadding={false}>
      <div className="w-full max-w-[540px]">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-[#EEF1F3] pb-1 px-4 pt-3">
          <h2 className="text-xl font-medium text-[#0C0C0E]">Add Country</h2>
          <button
            onClick={onClose}
            className="text-[#4F535D] hover:text-[#6B7143] transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Form Body */}
        <div className="space-y-6 px-4 py-6">
          {/* Country Name */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-[#383B41]">
              Country Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleChange}
              placeholder="e.g United States, Nigeria"
              className="w-full rounded-xl border border-[#D9DBDE] px-4 py-3.5 placeholder:text-gray-300 outline-none focus:border-gray-400 transition-all shadow-sm"
            />
          </div>
        </div>

        {/* Footer Actions */}
        <div className="flex gap-4 px-4 py-3 border-t border-[#EEF1F3]">
          <button
            onClick={onClose}
            className="flex-1 rounded-xl bg-gradient-to-r from-white to-[#F3F3F3] border border-[#D9DBDE] py-3.5 text-base font-medium text-[#4F535D] hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isPending}
            className="flex-1 rounded-xl bg-[#D9C9B8] py-3.5 text-base font-medium text-gray-800 hover:bg-[#C8B8A7] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AddCountryModal;
